import './footer.scss';

import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Footer = () => (
  <div className="footer page-content">
    <Row>
      <Col md="12">
        <p>This is your footer</p>
      </Col>
    </Row>
  </div>
);

export default Footer;
